import React from 'react'
import classnames from 'classnames'

import styles from './styles.module.scss'

type ListAndMapTogglerProps = {
  map?: boolean
  onClick?: (button: 'list' | 'map') => void
}

export const ListAndMapToggler = ({ map, onClick }: ListAndMapTogglerProps) => (
  <div className={styles.buttons}>
    <button
      className={classnames({ [styles.active]: !map })}
      onClick={() => onClick && onClick('list')}
    >
      <strong>Ver lista</strong>
    </button>
    <button
      disabled={map}
      className={classnames({ [styles.active]: map })}
      onClick={() => onClick && onClick('map')}
    >
      <strong>Ver mapa</strong>
    </button>
  </div>
)
